import React, { useState, useEffect } from "react";
import { Box, FormControl, Select, InputLabel, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "../../../../lib/axios";
import { useForm } from "react-hook-form";
import TableHead from '@mui/material/TableHead';
import { CancelPresentation as CancelPresentationIcon } from "@mui/icons-material";
import axiosInstance from "../../../../lib/axios";
import {
    Typography, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Paper, TextField, Button, Grid
} from "@mui/material";
import { Breadcrumbs, Link } from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const columns = [
    { id: 'RoomTypeName', label: 'RoomType', minWidth: 80 },
    { id: 'Topupdays', label: 'Days', minWidth: 70 },
];

export default function TopupTable() {
    const { register, watch, reset, setValue } = useForm();
    const [page, setPage] = useState(0);
    const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [searchTerms, setSearchTerms] = useState({});
    const [rows, setRows] = useState([]);
    const [RoomTypeDrp, setRoomTypeDrp] = useState([]);
    const [TopupConfigs, setTopupConfigs] = useState([]);
    const [PropertyDrp, setPropertyDrp] = useState([]);
    let DupTopupConfigs = [];
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            await fetchCompanyData();
            await fetchPropertyData();
        }
        fetchData();
    }, [])

    useEffect(() => {
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
                let id = String(rows[i].TopupID);
                setValue(id, rows[i].TopupAmt);
            }
        }
    }, [rows])

    const fetchCompanyData = async () => {
        try {
            const response = await axios.post(`RoomTypeMst/getAllRoomTypeMstDashBoard`, {
                "start": 1,
                "PageSize": 1,
                "SearchText": ""
            });

            if (response.data.Status === 0) {
                setRoomTypeDrp(response.data.Data);
            } else {
                console.error('Error fetching promocode data:', response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching promocode data:', error);
        }
    };


    const fetchPropertyData = async () => {
        const Flag = "";
        try {
            const response = await axiosInstance.post(
                `PropertyMst/GetPropertyMstUserwisedrp`,
                { Flag, UserId },
            );
            if (response.data.Status === 0) {
                setPropertyDrp(response.data.Data);
                setValue("PropId", response.data.Data[0].Id);
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };

    const handleRoomTypeIdChange = async (e) => {
        console.log(e.target.name, e.target.value);
        setValue(e.target.name, e.target.value);
        if (e.target.name === "PropId") {
            if (watch("RoomTypeId") === "") return;
        } else {
            if (watch("PropId") === "") {
                toast.info("Select Property!");
                return;
            }
        }
        try {
            const response = await axiosInstance.post(`MstTopup/GetMstTopupDashBoard`, {
                "RoomTypeId": watch("RoomTypeId"),
                "PropId": watch("PropId"),
                "Flag": ""
            });
            if (response.data.Status === 0) {
                setRows(response.data.Data);
            } else {
                console.error('Error fetching promocode data:', response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching promocode data:', error);
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleSearchChange = (columnId, value) => {
        setSearchTerms(prev => ({ ...prev, [columnId]: value }));
        setPage(0);
    };

    const filteredRows = React.useMemo(() => {
        return rows.filter(row => {
            return Object.entries(searchTerms).every(([columnId, term]) => {
                if (!term) return true;
                const value = row[columnId];
                if (typeof value === 'string') {
                    return value.toLowerCase().includes(term.toLowerCase());
                } else if (typeof value === 'number') {
                    return value.toString().includes(term);
                }
                return true;
            });
        });
    }, [searchTerms, rows]);

    const handleRowDoubleClick = (row) => {
        navigate('/promomaster', { state: { PromoCodeID: row.PromoCodeID, mode: 'view' } });
    };

    const handleLocationclick = () => {
        navigate('/masters/company')
    }

    const handleAmountChange = (e, row) => {
        let Amount = parseInt(e.target.value);
        setValue(e.target.name, Amount);
        // DupTopupConfigs = [...TopupConfigs];
        let objIndex = DupTopupConfigs.findIndex(obj => obj.Topupdays === row.Topupdays);
        if (objIndex < 0) {
            let obj = {
                "RoomTypeId": row.RoomTypeId,
                "Topupdays": row.Topupdays,
                "TopupAmt": Amount,
                "UpdatedBy": UserId,
                "PropId": watch("PropId"),
            }
            DupTopupConfigs.push(obj);
        } else {
            DupTopupConfigs[objIndex].TopupAmt = Amount
        }
    };

    const handleClose = () => {
        navigate('/masters/company');
    }

    const handleClick = async () => {
        let TopupConfigs = [...DupTopupConfigs];
        let FormattedObj = JSON.stringify({ TopupConfigs }).replace(/"/g, '\\"');
        FormattedObj = '"' + FormattedObj + '"';

        try {
            const response = await axios.post(`MstTopup/ManageMstTopupConfig`, FormattedObj);
            if (response.data.Status === 0) {
                toast.success(response.data.Message);
            } else {
                console.error('Error fetching promocode data:', response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching promocode data:', error);
        }
    };

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                overflowX: "hidden",
                backgroundColor: "#f9f9f9",
                minHeight: "100vh",
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: '#ffffff',
                    padding: '12px 32px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    borderRadius: '12px',
                    margin: '10px auto',
                    maxWidth: '95%',
                }}
            >
                <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ fontSize: '16px' }}>
                    <Link onClick={handleHomeClick} underline="hover" color="#635bff" sx={{ cursor: 'pointer' }}>
                        Home
                    </Link>
                    <Typography color="#635bff" onClick={handleLocationclick} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
                        Company
                    </Typography>
                    <Typography color="text.primary" sx={{ fontWeight: 'bold' }}>TopUp Master</Typography>
                </Breadcrumbs>

                {/* <FaFileExcel style={{ position: 'relative', left: '280px', color: 'green', fontSize: '30px' }}/> */}

            </Box>
            <Paper
                sx={{
                    width: "90%",
                    overflow: "hidden",
                    margin: "10px auto", // Center the Paper

                    borderRadius: "12px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    padding: "5px",
                    marginX: "auto"
                }}
            >
                <Box sx={{ maxWidth: { xs: '100%', md: '100%' }, overflowX: 'hidden', backgroundColor: '#f9f9f9' }}>
                    <Paper
                        sx={{
                            maxWidth: { xs: '100%', md: '50%' },
                            overflow: "hidden",
                            margin: "0  auto",
                            border: "1px solid lightgray",
                            padding: "10px"
                        }}
                    >
                        {/* <Box sx={{ display: "flex", justifyItems: "space-between", gap: "16px" }}> */}
                        <Grid container spacing={2}>
                            {/* Property List Dropdown */}
                            <Grid item md={4} xs={12} >
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="companyName-select-label">
                                        <span>
                                            Property List <span style={{ color: "red" }}>*</span>
                                        </span>
                                    </InputLabel>
                                    <Select
                                        labelId="companyName-select-label"
                                        id="PropId"
                                        name="PropId"
                                        value={watch('PropId') || ''}
                                        className="custom-textfield"
                                        {...register('PropId')}
                                        onChange={handleRoomTypeIdChange}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    overflow: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        {PropertyDrp.length > 0 &&
                                            PropertyDrp.map((type) => (
                                                <MenuItem key={type.Id} value={type.Id}>
                                                    {type.Name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Room Type Dropdown */}

                            <Grid item md={4} xs={12} >
                                <FormControl variant="filled" fullWidth className="custom-select">
                                    <InputLabel id="property-select-label">Room Type</InputLabel>
                                    <Select
                                        name="RoomTypeId"
                                        value={watch('RoomTypeId') || ''}
                                        {...register('RoomTypeId')}
                                        onChange={handleRoomTypeIdChange}
                                        className="custom-textfield"
                                    >
                                        {RoomTypeDrp.map((obj) => (
                                            <MenuItem key={obj.RoomTypeId} value={obj.RoomTypeId}>
                                                {obj.RoomTypeName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Update Button */}
                            <Grid item md={2} xs={8}
                                sx={{
                                    textAlign: { xs: 'right', md: 'center' },
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={handleClick}
                                    size="small"
                                    sx={{
                                        background: '#635bff',
                                        height: { md: '85%' },
                                        width: { md: '85%' },
                                        color: 'white',
                                        borderRadius: '5px',
                                        padding: '8px 20px',
                                    }}
                                >
                                    Update
                                </Button>
                            </Grid>

                            {/* Cancel Button */}
                            <Grid item md={2} xs={4}
                                sx={{
                                    textAlign: { xs: 'right', md: 'center' },
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    size="small"
                                    sx={{
                                        background: '#635bff',
                                        height: { md: '85%' },
                                        width: { md: '65%' },
                                        color: 'white',
                                        borderRadius: '5px',
                                        padding: '8px 20px',
                                    }}
                                >
                                    <CancelPresentationIcon
                                        variant="contained"
                                        size="medium"
                                        colour="primary"

                                        style={{ cursor: 'pointer' }}
                                    />
                                </Button>
                            </Grid>
                        </Grid>

                        <TableContainer sx={{ marginTop: "5px", width: "100%" }}>
                            <Table stickyHeader aria-label="sticky table" >
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            "& > th": {
                                                padding: "2px  10px 2px  10px",
                                            },
                                        }}
                                    >
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                style={{ width: column.minWidth }}
                                            >
                                                <Typography variant="subtitle1" fontWeight="bold">
                                                    {column.label}
                                                </Typography>
                                                {/* <TextField
                                                    size="small"
                                                    variant="outlined"
                                                    placeholder={`Search ${column.label}`}
                                                    value={searchTerms[column.id]}
                                                    onChange={(e) =>
                                                        handleSearchChange(column.id, e.target.value)
                                                    }
                                                    sx={{
                                                        mt: 1,
                                                        margin: "0px",
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "2px 2px",
                                                        },
                                                    }}
                                                /> */}
                                            </TableCell>
                                        ))}
                                        <TableCell style={{ width: 30 }}>
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                Amount
                                            </Typography>
                                            {/* <TextField
                                                size="small"
                                                variant="outlined"
                                                placeholder={`Search Total Beds`}
                                                onChange={(e) =>
                                                    handleSearchChange("TotalBeds", e.target.value)
                                                }
                                                sx={{
                                                    mt: 1,
                                                    margin: "0px",
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "2px 6px",
                                                    },
                                                }}
                                            /> */}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredRows
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row, idx) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={idx}
                                                    style={{ cursor: "pointer" }}
                                                    sx={{
                                                        "& > td": {
                                                            padding: "2px  6px 2px  10px",
                                                        },
                                                    }}
                                                >
                                                    {columns.map((column) => {
                                                        const value = row[column.id];
                                                        return (
                                                            <TableCell key={column.id} align={column.align}>
                                                                {value}
                                                            </TableCell>
                                                        );
                                                    })}
                                                    <TableCell>
                                                        <TextField
                                                            variant="outlined"
                                                            type="number"
                                                            id={String(row.TopupID)}
                                                            name={String(row.TopupID)}
                                                            size="small"
                                                            value={watch('TopupID')}
                                                            {...register(String(row.TopupID))}

                                                            onChange={(event) => handleAmountChange(event, row)}
                                                            sx={{
                                                                "& .MuiOutlinedInput-input": {
                                                                    padding: "2px 6px",
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 50, 100]}
                            component="div"
                            count={filteredRows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                </Box>
            </Paper>
        </Box>
    );
} 